import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  _localStorage: Storage;

  constructor() {
    this._localStorage = localStorage;
  }

  public setItem(key: string, value: string | JSON): void {
    if (value) {
      const toValue = (typeof value === 'object') ? JSON.stringify(value) : value;
      this._localStorage.setItem(key, toValue)
    } else {
      this._localStorage.removeItem(key);
    }
  }

  public getItem(key: string): string | JSON | null {
    const value = this._localStorage.getItem(key) || '';
    try { return JSON.parse(value) }
    catch (e) { return value }
  }

  public removeItem(key: string): void {
    this._localStorage.removeItem(key);
  }

  public clear(): void {
    this._localStorage.clear();
  }
}